import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { mediaUrl } from "../../lib/api";
import { useI18n } from "../../lib/i18n";
import { useBi } from "../../lib/customer";
import { Reveal } from "../Common";

export function About({ about }) {
  const b = useBi();
  const { tr } = useI18n();
  if (!about) return null;
  return (
    <section data-testid="home-about" className="container-lux grid items-center gap-12 py-24 lg:grid-cols-12 lg:gap-16 lg:py-32">
      <Reveal className="relative lg:col-span-5">
        <div className="relative aspect-[4/5] overflow-hidden rounded-sm border border-fg/10">
          {about.image && <img src={mediaUrl(about.image)} alt={b("Landmark Future residence interior", "تصميم داخلي لمشروع لاندمارك فيوتشر")} loading="lazy" data-testid="home-about-image" className="h-full w-full object-cover" />}
          <div className="absolute inset-0 bg-gradient-to-t from-canvas/40 to-transparent" aria-hidden="true" />
        </div>
        <div className="mashrabiya absolute -bottom-8 -end-8 -z-10 hidden h-48 w-48 opacity-20 lg:block" aria-hidden="true" />
      </Reveal>
      <Reveal delay={0.12} className="lg:col-span-6 lg:col-start-7">
        <p className="eyebrow mb-6">{b("About Landmark Future", "عن لاندمارك فيوتشر")}</p>
        <h2 data-testid="home-about-title" className="h-display text-3xl leading-tight sm:text-4xl lg:text-5xl">{tr(about, "title")}</h2>
        <p data-testid="home-about-body" className="mt-7 text-base leading-relaxed text-fg/70 md:text-lg">{tr(about, "body")}</p>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/about" data-testid="home-about-learn-more" className="btn-cta">{b("Learn more", "اعرف المزيد")}<ArrowRight className="rtl-flip h-4 w-4" /></Link>
          <Link to="/vision-mission" data-testid="home-about-vision" className="btn-ghost">{b("Vision & Mission", "الرؤية والرسالة")}</Link>
        </div>
      </Reveal>
    </section>
  );
}
